import styled from 'styled-components'

const StyledScheduleSlide = styled.div`
  
`

export default StyledScheduleSlide
